// router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import Login from '../views/Login.vue'
// import Register from '../views/Register.vue'
import Register from '../views/Register/Register.vue'
import RegisterPublic from '../views/RegisterPublic/index.vue'
import Registrasiuser from '../views/ApproveRegister/index.vue'
import VerifikasiUser from '../views/VerifiasiUser/index.vue'
import NotFoundComponent from '../views/404.vue' // Ganti jangan Login
import Profile from '../views/Profile.vue'
import Myprofile from '../views/Myprofile.vue'
import GraphAnalysisFullScreen from '../views/GraphAnalysisFullScreen.vue'
import LandingPage from '../views/LandingPage.vue'
import LandingPageCMS from '@/views/LandingPageCMS.vue'
// import Pinned from '../views/Pinned.vue'
// import Menumanagement from '../views/Menumanagement.vue'

Vue.use(VueRouter)

const staticRoutes = [
  // {
  //   path: '/menumanagement',
  //   name: 'menumanagement',
  //   component: Menumanagement
  // },
  { path: '/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/register-public', name: 'register-public', component: RegisterPublic },
  {
    path: '/verify-email',
    name: 'verify-email',
    component: VerifikasiUser
  },
  { path: '/profile', name: 'profile', component: Profile },
  { path: '/myprofile', name: 'myprofile', component: Myprofile },
  { path: '/GraphAnalysisFullScreen', name: 'GraphAnalysisFullScreen', component: GraphAnalysisFullScreen },
  { path: '/', name: 'landingpage', component: LandingPage },
  { path: '/landingpagecms', name: 'landingpagecms', component: LandingPageCMS },
  {
    path: '/registrasiuser/:userId',
    name: 'registrasiuser',
    component: Registrasiuser,
    props: true,
  },
  // { path: '/pinned', name: 'pinned', component: Pinned }
  {
    path: '/SettingGroupAnalysis',
    name: 'SettingGroupAnalysis',
    component: () => import('../views/PinnedAccount/SettingGroupAnalysis/index.vue')
  },
]

function resolveComponent(name) {
  return () => import(`../views/${name}.vue`).catch(() => NotFoundComponent)
}
export async function createRouter() {
  const dynamicRoutes = []

  try {
    const res = await axios.post('/groupPrivilage', {
      name_query: 'menu_routes',
      query: ''
    }, {
      headers: {
        'auth-token': localStorage.getItem('token_app')
      }
    })
    const menus = res.data.menuaccess || []
      menus.forEach(menu => {
        const rawPath = (menu.MODULE_URL || '').trim()
        if (!rawPath) {
          // console.warn('Skipping empty MODULE_URL for:', menu)
          return
        }
        const path = rawPath.startsWith('/') ? rawPath : `/${rawPath}`
        const componentName = menu.MODULE_VAR || menu.MODULE_VAR
        if (!componentName) {
          console.warn('Skipping due to missing component name:', menu)
          return
        }
        dynamicRoutes.push({
          path,
          name: menu.MODULE_NAME,
          component: resolveComponent(componentName)
        })
      })
  } catch (err) {
    console.error('Failed to load dynamic routes:', err)
  }
  const router =  new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [...staticRoutes, ...dynamicRoutes, { path: '*', component: NotFoundComponent }]
  })

  router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0)

    if (to.name === 'landingpage') {
      const token = localStorage.getItem('token_app')

      if (!token) {
        next()
        return
      }

      axios.post('decode-token', {}, {
        headers: { 'auth-token': token },
        dataType: 'json'
      })
        .then((response) => {
          if (response.status === 200) {
            let menuPrivilage = JSON.parse(localStorage.getItem('menuPrivilage'))
            let module_id = localStorage.getItem('module')
            let target = null

            for (const menuact of menuPrivilage) {
              if (module_id == menuact.MODULE_ID) {
                target = menuact.MODULE_URL
                break
              }
            }

            next(target ? { path: target } : { path: '/dashboard' })
          } else {
            next()
          }
        })
        .catch((e) => {
          console.log(e)
          next()
        })
      return
    }

    next()
  })

  setupUmami(router)

  return router;
}

function setupUmami(router) {
  router.afterEach((to) => {
    const userName = localStorage.getItem("userName");

    const run = () => {
      if (window.umami) {
        if (userName && window.umami.identify) {
          window.umami.identify(userName);
        }

        if (window.umami.trackView) {
          window.umami.trackView(to.fullPath);
        }
      }
    };

    // retry sampai umami ready
    if (!window.umami) {
      setTimeout(run, 100);
    } else {
      run();
    }
  })
}